import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
  path: '',
  component: () => import_latest_version_module(),
  children: [
    {
      path: '/admin/buyer/opening-mall-yes',
      name: 'admin-buyeropening-mall-yes',
      component: () => import(/* webpackChunkName: "page-admin-buyer-management-opening-mall-yes" */ `./1.0.1/index.vue`),
      meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "开通微商城"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "分销商管理"
                                        },
                                        {
                                                  name: "分销商列表"
                                        },
                                        {
                                                  name: "开通微商城"
                                        }
                              ]
                    }
          }
},
    },
  ],
};
